import styled from 'styled-components/macro';

const ArrowRightWrapper = styled.div`
  margin: 0 16px;

  svg {
    transform: rotate(90deg);
  }
`;

export default ArrowRightWrapper;
